// Millimetre-accurate SVG export: 1 user unit = 1 mm. The full document JSON
// is embedded in a metadata block so dragging the file back restores the
// design exactly.

import type { DocumentModel, GenResult, Poly } from '../core/types'

const P = 4 // coordinate decimals, 0.1 um resolution

function n(v: number): string {
  return Number(v.toFixed(P)).toString()
}

function polyPath(poly: Poly): string {
  let d = ''
  for (const ring of poly) {
    d += `M ${n(ring[0][0])} ${n(ring[0][1])}`
    for (let i = 1; i < ring.length; i++) d += ` L ${n(ring[i][0])} ${n(ring[i][1])}`
    d += ' Z '
  }
  return d.trim()
}

function escapeXml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

export function exportSvg(doc: DocumentModel, result: GenResult): string {
  const w = doc.canvas.width
  const h = doc.canvas.height
  const parts: string[] = []
  parts.push(
    `<svg xmlns="http://www.w3.org/2000/svg" width="${n(w)}mm" height="${n(h)}mm" viewBox="0 0 ${n(w)} ${n(h)}">`,
  )
  parts.push(`<metadata id="ventholes-document">${escapeXml(JSON.stringify(doc))}</metadata>`)

  // Boundary outline.
  if (result.boundaryCircle) {
    const c = result.boundaryCircle
    parts.push(
      `<circle cx="${n(c.cx)}" cy="${n(c.cy)}" r="${n(c.r)}" fill="none" stroke="black" stroke-width="0.1"/>`,
    )
  } else {
    parts.push(
      `<path d="${polyPath([result.boundary])}" fill="none" stroke="black" stroke-width="0.1"/>`,
    )
  }

  parts.push('<g fill="black" fill-rule="evenodd">')
  for (const hole of result.holes) {
    if (hole.circle) {
      const c = hole.circle
      parts.push(`<circle cx="${n(c.cx)}" cy="${n(c.cy)}" r="${n(c.r)}"/>`)
    } else {
      parts.push(`<path d="${polyPath(hole.poly)}"/>`)
    }
  }
  parts.push('</g>')
  parts.push('</svg>')
  return parts.join('\n')
}
